export default "__VITE_ASSET__DHrpQIKb__"